import React from 'react';

const Room = () => {
  return <div>Room</div>;
};

export default Room;
